/**
 * Analytics Provider Component
 * Wraps the app to provide automatic page tracking
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, setUserId, setUserProperties, trackLogin } from '../utils/analytics';

// Page title mapping
const PAGE_TITLES = {
  '/': 'Home',
  '/visas': 'All Visas',
  '/global-pass': 'Global Pass',
  '/applications': 'My Applications',
  '/profile': 'Profile',
  '/activity': 'Activity Log',
  '/consent/admin': 'Admin Consent',
  '/consent/agent': 'Agent Consent'
};

const getPageTitle = (pathname) => {
  // Check exact match first
  if (PAGE_TITLES[pathname]) {
    return PAGE_TITLES[pathname];
  }

  // Check dynamic routes
  if (pathname.startsWith('/visas/')) {
    return 'Visa Details';
  }
  if (pathname.startsWith('/applications/')) {
    return 'Application Details';
  }

  return 'App';
};

const AnalyticsProvider = ({ children, user }) => {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    const pageTitle = getPageTitle(location.pathname);
    trackPageView(location.pathname + location.search, pageTitle);
  }, [location]);

  // Set user ID and properties when user logs in
  useEffect(() => {
    if (user?.id) {
      setUserId(user.id.toString());
      setUserProperties(user.id.toString(), {
        has_admin_consent: user.has_admin_consent || false,
        has_agent_consent: user.has_agent_consent || false,
        profile_complete: !!(user.full_name && user.email)
      });
    }
  }, [user]);

  return children;
};

export default AnalyticsProvider;
